module.exports = __webpack_public_path__ + "img/heroimage.5b7c5371.png";